export const images = {
  logo: '/assets/images/meleon_logo.png',
};
